module.exports = __webpack_public_path__ + "static/img/trans_batch_download.c16d6a0c.gif";